import { render, staticRenderFns } from "./MarshallConfigRede.vue?vue&type=template&id=825f9980&"
import script from "./MarshallConfigRede.vue?vue&type=script&lang=js&"
export * from "./MarshallConfigRede.vue?vue&type=script&lang=js&"
import style0 from "./MarshallConfigRede.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MarshallConfigRede.vue"
export default component.exports